import {
  API_URL,
  DELAY,
  KV,
  ROLE_TYPE,
  SDK_CLIENT_TYPE,
  SDK_EVENT,
  SDK_PLAY_MODE,
  FORCE_DOC_TYPE
} from './../common/Constant';
import Http from './Http';
import log from 'loglevel';
import { deferQueue } from './deferQueue';
import pkg from '../../package.json';

const MAX_RETRIES = 5;
const RETRY_DELAY = 2000; // 2 seconds

function dateTimeStr(dt) {
  // (128 * 4096 * 4096 - 1) * 1000
  var d =
    Object.prototype.toString.apply(dt) === '[object Date]'
      ? dt
      : typeof dt === 'undefined'
      ? new Date()
      : new Date(dt);
  // eslint-disbale-nextline
  if (Number.isNaN(d.valueOf())) {
    // isNaN
    return '0000-00-00 00:00:00';
  }
  var ymd = ''
    .concat(d.getFullYear().toString(), '-')
    .concat((d.getMonth() + 1).toString().padStart(2, '0'), '-')
    .concat(d.getDate().toString().padStart(2, '0'));
  var hms = ''
    .concat(d.getHours().toString().padStart(2, '0'), ':')
    .concat(d.getMinutes().toString().padStart(2, '0'), ':')
    .concat(d.getSeconds().toString().padStart(2, '0'));
  return ''.concat(ymd, ' ').concat(hms);
}

/**
 * PAAS api接口封装
 *
 * @export
 * @class API
 */
export default class API extends deferQueue {
  constructor(app) {
    super();
    this._app = app;
    this.store = this._app.store;

    // const channelId = this.store.getKV(KV.CHANNEL_ID);
    this._delayHandler = this._delayHandler.bind(this);
    // if (!channelId) {
    //   log.error('does not exist channelId');
    //   return;
    // }

    this.message = this.store.getKV(KV.SOCKET_INSTANCE);
    // is v2.x.x msg api
    this.isV4 = !!(this.message && this.message.sdkName);
    this._forceV4 = this._app._forceV4;
    this._forceApiSend = this._app._forceApiSend;

    if (this.message) {
      if (this.isV4 && this._forceV4) {
        this.message.on('document', msg => {
          if (this._onMessageV4Handler) this._onMessageV4Handler(msg);
        });
      } else {
        this.message.addEventListener('service_document', msg => {
          if (this._onMessageHandler) this._onMessageHandler(msg);
        });
        if (VhallMsg.__ee__) {
          VhallMsg.__ee__.broadcast = [];
        }
      }
    }
    VhallMsg.onBroadcast(this._onBroadcastHandler.bind(this));
  }

  destroy() {
    this._onMessageHandler = null;
    this._onMessageV4Handler = null;
  }

  init(params) {
    if (params) {
      params.version = `jssdk_doc_${pkg.version}`;
    }
    return new Promise((resolve, reject) => {
      let http = new Http(this.store);
      http.fire(API_URL.INIT, params);
      http.onLoad = e => {
        resolve(e);
      };
      http.onError = e => {
        reject(e);
      };
    });
  }

  getDocInfo(docId) {
    const channelId = this.store.getKV(KV.CHANNEL_ID);
    return new Promise((resolve, reject) => {
      let http = new Http(this.store);
      http.fire(API_URL.GET_PUBLISH_INFO, {
        document_id: docId,
        channel_id: channelId
      });

      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  getWatchInfo(opts) {
    let channelId = this.store.getKV(KV.CHANNEL_ID);
    if (opts && opts.channelId) {
      channelId = opts.channelId;
    }

    return new Promise((resolve, reject) => {
      let http = new Http(this.store);
      http.fire(API_URL.GET_WATCH_INFO, {
        channel_id: channelId
      });

      http.onError = e => reject(e);
      http.onLoad = e => {
        // 重新设置文档开关状态
        if (e.switch_status !== 0) {
          this.store.setKV(KV.WATCH_ON, true);
        } else {
          this.store.setKV(KV.WATCH_ON, false);
        }
        resolve(e);
      };
    });
  }

  emitMessage(msg) {
    if (this.store.getKV(KV.ISRELAY)) return Promise.resolve();

    // v4 消息通过长链接发送
    if (this.isV4 && !this._forceApiSend) {
      return this.emitV4Message(msg);
    }

    return new Promise((resolve, reject) => {
      const channelId = this.store.getKV(KV.CHANNEL_ID);
      const roomId = this.store.getKV(KV.ROOM_ID) || '';

      if (typeof msg === 'string') {
        msg = JSON.parse(msg);
      }

      // 文档操作的所有消息里，均需要关联docId
      if (!msg.docId) {
        try {
          const doc = this._app.docMap.get(msg.cid);
          msg.docId = doc.docId || doc.store.getKV('passThrough').docId;
        } catch (error) {
          msg.docId = '';
        }
      }

      if (!msg.version) msg.version = process.env.VERSION;

      // 所有文档消息里，增加文档开关状态（目前仅为回放使用）
      msg.switch = this.store.getKV(KV.WATCH_ON);
      let obj = {};
      obj.type = 'service_document';
      obj.channel_id = channelId;
      obj.room_id = roomId;
      obj.body = JSON.stringify(msg);
      this.sendRequestWithRetry(obj, 0, resolve, reject);
    });
  }
  // 消息发送失败增加重试逻辑
  sendRequestWithRetry(obj, retryCount, resolve, reject) {
    let http = new Http(this.store);
    http.onTimeout = e => {
      this.handleError(obj, retryCount);
      reject && reject(e);
    };
    http.onError = e => {
      this.handleError(obj, retryCount);
      reject && reject(e);
    };
    http.onLoad = e => {
      resolve && resolve(e);
    };
    http.fire(API_URL.SEND_MESSAGE, obj);
  }

  handleError(obj, retryCount) {
    if (retryCount < MAX_RETRIES) {
      log.info(`The ${retryCount}th request failed. Retrying in ${RETRY_DELAY / 1000} seconds...`);
      setTimeout(() => {
        this.sendRequestWithRetry(obj, retryCount + 1);
      }, RETRY_DELAY);
    }
  }

  emitV4Message(msg) {
    if (!this.message) {
      return Promise.reject({ msg: '没有Msg实例' });
    }

    if (typeof msg === 'string') {
      msg = JSON.parse(msg);
    }

    // 文档操作的所有消息里，均需要关联docId
    if (!msg.docId) {
      try {
        const doc = this._app.docMap.get(msg.cid);
        msg.docId = doc.docId || doc.store.getKV('passThrough').docId;
      } catch (error) {
        msg.docId = '';
      }
    }

    if (!msg.version) msg.version = process.env.VERSION;
    // 所有文档消息里，增加文档开关状态（目前仅为回放使用）
    msg.switch = this.store.getKV(KV.WATCH_ON);

    // let obj = {};
    // obj.type = 'service_document';
    // obj.channel_id = channelId;
    // obj.room_id = roomId;
    // obj.body = JSON.stringify(msg);
    // 长链接发消息

    return this.message.send('document', msg);
  }

  resetContainer() {
    return new Promise((resolve, reject) => {
      const channelId = this.store.getKV(KV.CHANNEL_ID);
      let http = new Http(this.store);
      http.fire(API_URL.RESET, {
        channel_id: channelId
      });

      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  republish() {
    return new Promise((resolve, reject) => {
      let http = new Http(this.store);
      let obj = {};
      obj.channel_id = this.store.getKV(KV.CHANNEL_ID);
      http.fire(API_URL.REPUBLISH, obj);
      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  start(obj) {
    return new Promise((resolve, reject) => {
      let http = new Http(this.store);
      http.fire(API_URL.START, obj);
      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  getVodData(url) {
    return new Promise((resolve, reject) => {
      /** 由于 cuepoint 文件不遵循 通用的 response 格式，没有code，故走 onError获取 */
      let http = new Http(this.store);
      http.fire(url, {}, 'GET');
      http.onError = e => {
        const data = { data: e.cuepoint };
        resolve();
        this._app.setVodData(data);
      };
      http.onLoad = e => {
        resolve();
      };
      http.onTimeout = e => {
        reject(new Error('time out'));
      };
    });
  }

  getChapters(docId) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.fire(API_URL.GET_CHAPTERS, { document_id: docId });
      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  /** 上报当前章节信息 */
  reportChapters(param) {
    return new Promise((resolve, reject) => {
      let http = new Http(this.store);
      http.fire(API_URL.SEND_CHAPTERS, { body: JSON.stringify(param) });

      http.onError = e => reject(e);
      http.onLoad = e => resolve(e);
    });
  }

  /**
   * 接收文档消息v4
   */
  _onMessageV4Handler(ev) {
    // v4消息处理
    // debugger;
    const oldDocMessage = {
      msg_id: ev.msgId,
      app_id: ev.appId,
      channel: ev.channelId,
      service_type: 'service_document',
      msg_source: 'prefix01',
      date_time: dateTimeStr(ev.time) || '2038-01-19 03:14:07',
      sender_id: ev.sourceId || '',
      context: JSON.stringify(ev.context),
      data: JSON.stringify(ev.data),
      // 未使用
      client: 'pc_browser',
      // 未使用
      bu: '1',
      // 未使用
      pv: 1,
      // 未使用
      uv: 1
    };
    this._onMessageHandler(oldDocMessage);
  }

  /**
   * bind了 Main, 可以直接从this调用
   *
   * @param {*} e
   * @memberof API
   */
  _onMessageHandler(param) {
    // 根据客户端类型设置延迟
    const client = this.store.getKV(KV.CLIENT);
    const mode = this.store.getKV(KV.PLAY_MODE);
    const playDelay = this.store.getKV(KV.PLAY_DELAY);
    let delay = DELAY[`${client}_${mode}`] || DELAY[`${SDK_CLIENT_TYPE.PC_WEB}_${SDK_PLAY_MODE.FLV}`];
    if (playDelay !== -1) {
      delay = playDelay * 1000;
    }
    if (typeof param === 'string') {
      param = JSON.parse(param);
    }
    param = { ...param }; // 复制一个数据保证不被覆盖

    param.data = JSON.parse(param.data);
    let commands = param.data['command'];
    if (!commands || commands.length === 0) {
      log.error('数据非法', param);
      return;
    }
    let command = commands[0];
    if (!command.hasOwnProperty('event')) {
      log.error('数据不包含event字段');
      return;
    }
    const forceDocType = this.store.getKV(KV.FORCE_DOC_TYPE);
    if (forceDocType === FORCE_DOC_TYPE.DYNAMIC || forceDocType === FORCE_DOC_TYPE.STATIC) {
      if (command.event === 'onStepChange') return;
      param.data.doc_type && (param.data.doc_type = forceDocType);
      command.doc_type && (command.doc_type = forceDocType);
    }
    param._delay = delay;
    const role = this.store.getKV(KV.ROLE);
    if (role !== ROLE_TYPE.HOST) {
      this._push({ data: param, executeTime: Date.now() + param._delay, fn: this._delayHandler });
    } else {
      this._delayHandler(param);
    }
  }

  _delayHandler(e) {
    let app = this._app;
    let isSelf = false;
    if (e['sender_id']) {
      const senderId = e['sender_id'];
      const thirdPartyId = this.store.getKV(KV.THIRD_PARTY_USER_ID);
      /** 兼容转播  saas 的转播 accoutId 相同，此时不应该往外发送消息，收到的消息全部应该响应，课堂 转播的accountId不同，故没有此问题 */
      if (senderId == thirdPartyId && !this.store.getKV(KV.ISRELAY)) isSelf = true;
    }

    const command = e.data['command'][0];
    switch (command['event']) {
      case 'doodle':
      case 'onStepChange':
      case 'onSlideChange':
        // console.error('接收：', data.currentPage)
        if (!isSelf) {
          app.setData(e.data);
        }
        /**
         * 观看端也需要记录docId，否则当权限切换为发起端时，有一种情况会导致 emitmessage取不到 docId
         */
        let cid = e.data['cid'];
        let doc = app.docMap.get(cid);
        if (cid.indexOf('document') != -1) {
          doc && !doc.docId && (doc.docId = e.data.docId);
          if (doc) {
            doc.lastPageInfo = {
              slideIndex: command?.params?.slideIndex,
              stepIndex: command?.params?.stepIndex
            };
          }
        }
        let pageData = e.data['pageData'] || [];
        if (doc && pageData.length) {
          doc.setAllData(JSON.stringify(pageData));
        }
        break;
      case 'operate':
        if (isSelf) break;
        // this.operateHandler[command['type']](command['data'])
        switch (command['type']) {
          case 'create':
            app.emit(SDK_EVENT.CREATE_CONTAINER, command['data']);
            break;
          case 'destroy':
            app.emit(SDK_EVENT.DELETE_CONTAINER, command['data']);
            break;
          case 'active':
            app.emit(SDK_EVENT.SELECT_CONTAINER, {
              ...command['data'],
              cw: e.data.cw,
              ch: e.data.ch,
              backgroundColor: e.data.backgroundColor || null
            });
            break;
          case 'switchon':
            app.emit(SDK_EVENT.SWITCH_CHANGE, 'on');
            /**
             * 记录开关状态
             */
            this.store.setKV(KV.WATCH_ON, true);
            break;
          case 'switchoff':
            app.emit(SDK_EVENT.SWITCH_CHANGE, 'off');
            /**
             * 记录开关状态
             */
            this.store.setKV(KV.WATCH_ON, false);
            break;
          case 'reset':
            app.emit(SDK_EVENT.RESET_CONTAINER, command['data']);
            break;
          default:
            log.warn('不存在对应的operate类型处理', command['type']);
        }
        break;
      // 暂时无用，留空
      case 'ready':
        break;
      default:
        log.warn('不存在对应的event类型处理', command['event']);
    }
  }
  _onBroadcastHandler(e) {
    if (this.store.getKV(KV.ISVODRECORD)) return;
    switch (e.type) {
      case 'cue_point': {
        let cueData = JSON.parse(e.data);
        let cuepoint = cueData.cuepoint;
        const forceDocType = this.store.getKV(KV.FORCE_DOC_TYPE);
        if (forceDocType === FORCE_DOC_TYPE.DYNAMIC || forceDocType === FORCE_DOC_TYPE.STATIC) {
          let temp = [];
          for (let iterator of cuepoint) {
            let tempContent = JSON.parse(iterator.content2);
            let command = tempContent['command'][0];
            if (command.event === 'onStepChange') continue;
            tempContent.doc_type && (tempContent.doc_type = forceDocType);
            command.doc_type && (command.doc_type = forceDocType);
            iterator.content2 = JSON.stringify(tempContent);
            temp.push(iterator);
          }
          cuepoint = temp;
        }
        let data = { data: cuepoint } || { data: [] };
        const chapters = cueData.titles || [];
        // let data = { data: CUE.cuepoint } || { data: [] };
        // const chapters = CUE.titles || [];
        this._app.setVodData(data, chapters);

        break;
      }
      case 'time_update':
        let player = e.data.target;
        let time = player.currentTime;
        this._app.setVodTime(time);
        break;
      case 'delay':
        let delay = e.data.delay;
        this.store.setKV(KV.PLAY_DELAY, delay);
        break;
      default:
        log.warn(`未识别的消息类型:${e.type}`);
        break;
    }
  }
}
